import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, Inject, OnDestroy } from '@angular/core';
import { FileUploader, FileLikeObject, FileItem } from 'ng2-file-upload';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExcelImportService } from 'src/app/services/excel-import.service';
import { Constant } from 'src/app/constant/constant';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { OrderService } from 'src/app/services/order.service';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'calsoft-import-excel',
  templateUrl: './import-excel.component.html',
  styleUrls: ['./import-excel.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' },
  encapsulation: ViewEncapsulation.None
})
export class ImportExcelComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';
  title = 'Excel Import';

  item: FileLikeObject;
  data: any;
  text: string;
  faliedList: any = [];
  uploadedFile: boolean = false;
  validationErrors: Array<{ row: number | string; field: string; message: string }> = [];

  constructor(
    public excelImportService: ExcelImportService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<ImportExcelComponent>,
    private router: Router
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.data = data;
    if (this.data && !this.data.url && this.data.url1) {
      this.data.url = this.data.url1;
    }
    if (this.data && this.data.title) {
      this.title = this.data.title;
    }
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {
    this.text = 'Upload';
    this.s();
  }

  @ViewChild("dummyID")
  myInputVariable: ElementRef;

  @ViewChild("fileInput")
  fileInputVariable: ElementRef;

  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    allowedFileType: ['xls'],
    //maxFileSize: 5 * 1024 * 1024
  });

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  s() {
    let maxFileSize = 5 * 1024 * 1024;
    let queueLimit = 5;

    this.uploader.onAfterAddingFile = () => {
      this.validationErrors = [];
      this.uploadedFile = false;
      this.faliedList = [];
    };

    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      this.item = item;
      switch (filter.name) {
        case 'fileType':
          this.snackBar.open("Uploaded wrong file type, " + item.name, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 2000 });
          if (this.myInputVariable && this.myInputVariable.nativeElement) {
            this.myInputVariable.nativeElement.value = "";
          }
          if (this.fileInputVariable && this.fileInputVariable.nativeElement) {
            this.fileInputVariable.nativeElement.value = "";
          }
          break;
        case 'fileSize':
          this.snackBar.open("The file could not be uploaded because it exceeds 5MB, the maximum allowed size for uploads", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          break;
        default:
          break;
      }
    };
  }

  clearValidationErrors() {
    this.validationErrors = [];
    if (this.uploader) {
      this.uploader.clearQueue();
    }
    if (this.fileInputVariable && this.fileInputVariable.nativeElement) {
      this.fileInputVariable.nativeElement.value = "";
    }
  }

  hasRowProperty(list: any[]): boolean {
    return Array.isArray(list) && list.some(item => item && (item.row !== undefined || item.rowNumber !== undefined));
  }

  validateQuotationExcel(file: File): Promise<{ isValid: boolean; errors: Array<{ row: number | string; field: string; message: string }> }> {
    return new Promise((resolve) => {
      const errors: Array<{ row: number | string; field: string; message: string }> = [];
      const reader = new FileReader();

      reader.onload = (e: any) => {
        try {
          const buffer = e.target.result;
          const workbook = XLSX.read(buffer, { type: 'array', cellDates: true });

          if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
            errors.push({ row: '-', field: 'File', message: 'No sheets found in the uploaded workbook.' });
            return resolve({ isValid: false, errors });
          }

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          if (!worksheet) {
            errors.push({ row: '-', field: 'Sheet', message: 'The workbook contains an invalid or empty sheet.' });
            return resolve({ isValid: false, errors });
          }

          const rawData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

          if (!rawData || rawData.length === 0) {
            errors.push({ row: '-', field: 'Content', message: 'The uploaded Excel file contains no data.' });
            return resolve({ isValid: false, errors });
          }

          let headerRowIndex = -1;
          for (let i = 0; i < rawData.length; i++) {
            if (rawData[i] && rawData[i].some((cell: any) => cell !== null && cell !== undefined && String(cell).trim() !== '')) {
              headerRowIndex = i;
              break;
            }
          }

          if (headerRowIndex === -1) {
            errors.push({ row: '-', field: 'Content', message: 'The uploaded file is empty.' });
            return resolve({ isValid: false, errors });
          }

          const rawHeaders: any[] = rawData[headerRowIndex];
          const headerMap: { [key: string]: number } = {};

          rawHeaders.forEach((h: any, colIdx: number) => {
            if (h !== null && h !== undefined) {
              const clean = String(h).toLowerCase().replace(/[^a-z0-9]/g, '');
              if (clean) {
                headerMap[clean] = colIdx;
              }
            }
          });

          const findCol = (aliases: string[]): number => {
            for (const alias of aliases) {
              const cleanAlias = alias.toLowerCase().replace(/[^a-z0-9]/g, '');
              if (headerMap[cleanAlias] !== undefined) {
                return headerMap[cleanAlias];
              }
            }
            return -1;
          };

          const colDate = findCol(['date', 'quotationdate', 'quotedate', 'orderdate']);
          const colRef = findCol(['referenceno', 'refno', 'referencenumber', 'reference', 'quoteid', 'quotationno']);
          const colCustomer = findCol(['customer', 'customername', 'client', 'clientname', 'customerid']);
          const colBiller = findCol(['biller', 'billername', 'company', 'branch']);
          const colSupplier = findCol(['supplier', 'suppliername', 'vendor', 'vendorname']);
          const colTotal = findCol(['total', 'grandtotal', 'amount', 'totalamount', 'nettotal']);
          const colStatus = findCol(['status', 'quotestatus', 'quotationstatus']);
          const colProductName = findCol(['productname', 'product', 'itemname', 'item']);
          const colProductCode = findCol(['productcode', 'itemcode', 'sku', 'code']);
          const colQuantity = findCol(['quantity', 'qty']);
          const colUnitPrice = findCol(['unitprice', 'netunitprice', 'price', 'rate']);

          const matchedCols = [colDate, colRef, colCustomer, colBiller, colTotal, colProductName, colProductCode].filter(c => c !== -1);
          if (matchedCols.length === 0) {
            errors.push({
              row: 'Header',
              field: 'Columns',
              message: 'Invalid template. Required quotation headers (Date, Reference No, Customer, Total) were not found.'
            });
            return resolve({ isValid: false, errors });
          }

          const missingCols: string[] = [];
          if (colDate === -1) missingCols.push('Date');
          if (colRef === -1) missingCols.push('Reference No');
          if (colCustomer === -1) missingCols.push('Customer');
          if (colTotal === -1 && (colQuantity === -1 || colUnitPrice === -1)) missingCols.push('Total');

          if (missingCols.length > 0) {
            errors.push({
              row: 'Header',
              field: missingCols.join(', '),
              message: `Missing required column(s): ${missingCols.join(', ')}.`
            });
            return resolve({ isValid: false, errors });
          }

          let dataRowCount = 0;
          for (let r = headerRowIndex + 1; r < rawData.length; r++) {
            const row = rawData[r];
            if (!row || !row.some((c: any) => c !== null && c !== undefined && String(c).trim() !== '')) {
              continue;
            }

            dataRowCount++;
            const displayRowNum = r + 1;

            const getCell = (colIdx: number): any => {
              if (colIdx === -1 || !row || row[colIdx] === undefined || row[colIdx] === null) return '';
              return row[colIdx];
            };

            const isEmpty = (val: any): boolean => {
              if (val === null || val === undefined) return true;
              return String(val).trim() === '';
            };

            // 1. Validate Date
            if (colDate !== -1) {
              const dateVal = getCell(colDate);
              if (isEmpty(dateVal)) {
                errors.push({
                  row: displayRowNum,
                  field: 'Date',
                  message: 'Date is required.'
                });
              } else {
                let isValidDate = false;
                if (dateVal instanceof Date && !isNaN(dateVal.getTime())) {
                  isValidDate = true;
                } else if (typeof dateVal === 'number' && dateVal > 0 && dateVal < 100000) {
                  isValidDate = true;
                } else {
                  const dStr = String(dateVal).trim();
                  const parsed = Date.parse(dStr);
                  if (!isNaN(parsed)) {
                    isValidDate = true;
                  } else {
                    const parts = dStr.split(/[-/.]/);
                    if (parts.length === 3) {
                      const d = parseInt(parts[0], 10);
                      const m = parseInt(parts[1], 10);
                      const y = parseInt(parts[2], 10);
                      if (!isNaN(d) && !isNaN(m) && !isNaN(y) && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
                        isValidDate = true;
                      }
                    }
                  }
                }
                if (!isValidDate) {
                  errors.push({
                    row: displayRowNum,
                    field: 'Date',
                    message: `Invalid date format '${dateVal}'. Expected a valid date (e.g. YYYY-MM-DD or DD/MM/YYYY).`
                  });
                }
              }
            }

            // 2. Validate Reference No
            if (colRef !== -1) {
              const refVal = getCell(colRef);
              if (isEmpty(refVal)) {
                errors.push({
                  row: displayRowNum,
                  field: 'Reference No',
                  message: 'Reference No is required.'
                });
              }
            }

            // 3. Validate Customer
            if (colCustomer !== -1) {
              const custVal = getCell(colCustomer);
              if (isEmpty(custVal)) {
                errors.push({
                  row: displayRowNum,
                  field: 'Customer',
                  message: 'Customer is required.'
                });
              }
            }

            // 4. Validate Total
            if (colTotal !== -1) {
              const totalVal = getCell(colTotal);
              if (isEmpty(totalVal)) {
                errors.push({
                  row: displayRowNum,
                  field: 'Total',
                  message: 'Total is required.'
                });
              } else {
                const cleanedTotal = String(totalVal).replace(/[$₹, ]/g, '').trim();
                const num = Number(cleanedTotal);
                if (isNaN(num)) {
                  errors.push({
                    row: displayRowNum,
                    field: 'Total',
                    message: `Invalid Total '${totalVal}'. Numeric value expected.`
                  });
                } else if (num < 0) {
                  errors.push({
                    row: displayRowNum,
                    field: 'Total',
                    message: `Total cannot be negative (${totalVal}).`
                  });
                }
              }
            }

            // 5. Validate Status (if present)
            if (colStatus !== -1) {
              const statusVal = getCell(colStatus);
              if (!isEmpty(statusVal)) {
                const sStr = String(statusVal).trim().toLowerCase();
                const validStatuses = ['0', '1', 'pending', 'sent', 'completed', 'active', 'draft', 'approved', 'rejected', 'cancelled'];
                if (!validStatuses.includes(sStr)) {
                  errors.push({
                    row: displayRowNum,
                    field: 'Status',
                    message: `Invalid status '${statusVal}'. Expected 'Pending' or 'Sent'.`
                  });
                }
              }
            }

            // 6. Validate Quantity (if present)
            if (colQuantity !== -1) {
              const qtyVal = getCell(colQuantity);
              if (!isEmpty(qtyVal)) {
                const num = Number(String(qtyVal).replace(/[, ]/g, ''));
                if (isNaN(num) || num <= 0) {
                  errors.push({
                    row: displayRowNum,
                    field: 'Quantity',
                    message: `Quantity must be a positive number greater than 0.`
                  });
                }
              }
            }

            // 7. Validate Unit Price (if present)
            if (colUnitPrice !== -1) {
              const priceVal = getCell(colUnitPrice);
              if (!isEmpty(priceVal)) {
                const num = Number(String(priceVal).replace(/[$₹, ]/g, ''));
                if (isNaN(num) || num < 0) {
                  errors.push({
                    row: displayRowNum,
                    field: 'Unit Price',
                    message: `Unit Price must be a valid non-negative number.`
                  });
                }
              }
            }

            // 8. Validate Item Name/Code if line item row
            if (colProductName !== -1 || colProductCode !== -1) {
              const pName = getCell(colProductName);
              const pCode = getCell(colProductCode);
              if (isEmpty(pName) && isEmpty(pCode) && (!isEmpty(getCell(colQuantity)) || !isEmpty(getCell(colUnitPrice)))) {
                errors.push({
                  row: displayRowNum,
                  field: 'Product Name / Code',
                  message: 'Product Name or Product Code is required.'
                });
              }
            }
          }

          if (dataRowCount === 0) {
            errors.push({
              row: '-',
              field: 'Content',
              message: 'The uploaded file does not contain any data rows.'
            });
          }

          return resolve({ isValid: errors.length === 0, errors });
        } catch (err) {
          errors.push({
            row: '-',
            field: 'File',
            message: `Error reading file: ${err?.message || 'Invalid Excel format'}`
          });
          return resolve({ isValid: false, errors });
        }
      };

      reader.onerror = () => {
        errors.push({ row: '-', field: 'File', message: 'Unable to read the uploaded file.' });
        resolve({ isValid: false, errors });
      };

      reader.readAsArrayBuffer(file);
    });
  }

  validateProductExcel(file: File): Promise<{ isValid: boolean; errors: Array<{ row: number | string; field: string; message: string }> }> {
    return new Promise((resolve) => {
      const errors: Array<{ row: number | string; field: string; message: string }> = [];
      const reader = new FileReader();

      reader.onload = (e: any) => {
        try {
          const buffer = e.target.result;
          const workbook = XLSX.read(buffer, { type: 'array', cellDates: true });

          if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
            errors.push({ row: '-', field: 'File', message: 'No sheets found in the uploaded workbook.' });
            return resolve({ isValid: false, errors });
          }

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          if (!worksheet) {
            errors.push({ row: '-', field: 'Sheet', message: 'The workbook contains an invalid or empty sheet.' });
            return resolve({ isValid: false, errors });
          }

          const rawData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

          if (!rawData || rawData.length === 0) {
            errors.push({ row: '-', field: 'Content', message: 'The uploaded Excel file contains no data.' });
            return resolve({ isValid: false, errors });
          }

          let headerRowIndex = -1;
          for (let i = 0; i < rawData.length; i++) {
            if (rawData[i] && rawData[i].some((cell: any) => cell !== null && cell !== undefined && String(cell).trim() !== '')) {
              headerRowIndex = i;
              break;
            }
          }

          if (headerRowIndex === -1) {
            errors.push({ row: '-', field: 'Content', message: 'The uploaded file is empty.' });
            return resolve({ isValid: false, errors });
          }

          const rawHeaders: any[] = rawData[headerRowIndex];
          const headerMap: { [key: string]: number } = {};

          rawHeaders.forEach((h: any, colIdx: number) => {
            if (h !== null && h !== undefined) {
              const clean = String(h).toLowerCase().replace(/[^a-z0-9]/g, '');
              if (clean) {
                headerMap[clean] = colIdx;
              }
            }
          });

          const findCol = (aliases: string[]): number => {
            for (const alias of aliases) {
              const cleanAlias = alias.toLowerCase().replace(/[^a-z0-9]/g, '');
              if (headerMap[cleanAlias] !== undefined) {
                return headerMap[cleanAlias];
              }
            }
            for (const alias of aliases) {
              const cleanAlias = alias.toLowerCase().replace(/[^a-z0-9]/g, '');
              for (const k of Object.keys(headerMap)) {
                if (k.includes(cleanAlias) || cleanAlias.includes(k)) {
                  return headerMap[k];
                }
              }
            }
            return -1;
          };

          const colCost = findCol(['cost', 'productcost', 'costprice', 'unitcost', 'netunitcost', 'purchasecost', 'buyingprice', 'purchaseprice']);
          const colPrice = findCol(['price', 'productprice', 'mrp', 'sellingprice', 'unitprice', 'saleprice', 'retailprice', 'regularprice']);

          let dataRowCount = 0;
          for (let r = headerRowIndex + 1; r < rawData.length; r++) {
            const row = rawData[r];
            if (!row || !row.some((c: any) => c !== null && c !== undefined && String(c).trim() !== '')) {
              continue;
            }

            dataRowCount++;
            const displayRowNum = r + 1;

            const getCell = (colIdx: number): any => {
              if (colIdx === -1 || !row || row[colIdx] === undefined || row[colIdx] === null) return '';
              return row[colIdx];
            };

            const isEmpty = (val: any): boolean => {
              if (val === null || val === undefined) return true;
              return String(val).trim() === '';
            };

            const parseNumeric = (val: any): number | null => {
              if (isEmpty(val)) return null;
              const s = String(val).replace(/[$₹, ]/g, '').trim();
              if (s === '') return null;
              const num = Number(s);
              return isNaN(num) ? null : num;
            };

            const costRaw = getCell(colCost);
            const priceRaw = getCell(colPrice);

            let costNum: number | null = null;
            let priceNum: number | null = null;

            if (colCost !== -1 && !isEmpty(costRaw)) {
              costNum = parseNumeric(costRaw);
              if (costNum === null) {
                errors.push({
                  row: displayRowNum,
                  field: 'Cost',
                  message: `Invalid Cost '${costRaw}'. Must be a valid numeric value.`
                });
              } else if (costNum < 0) {
                errors.push({
                  row: displayRowNum,
                  field: 'Cost',
                  message: 'Cost cannot be negative.'
                });
              }
            }

            if (colPrice !== -1 && !isEmpty(priceRaw)) {
              priceNum = parseNumeric(priceRaw);
              if (priceNum === null) {
                errors.push({
                  row: displayRowNum,
                  field: 'Price',
                  message: `Invalid Price '${priceRaw}'. Must be a valid numeric value.`
                });
              } else if (priceNum < 0) {
                errors.push({
                  row: displayRowNum,
                  field: 'Price',
                  message: 'Price cannot be negative.'
                });
              }
            }

            // Validation: Price must not be lower than Cost
            if (costNum !== null && priceNum !== null && costNum >= 0 && priceNum >= 0) {
              if (priceNum < costNum) {
                errors.push({
                  row: displayRowNum,
                  field: 'Price',
                  message: `Price (${priceNum}) cannot be lower than Cost (${costNum}).`
                });
              }
            }
          }

          if (dataRowCount === 0) {
            errors.push({
              row: '-',
              field: 'Content',
              message: 'The uploaded file does not contain any data rows.'
            });
          }

          return resolve({ isValid: errors.length === 0, errors });
        } catch (err) {
          errors.push({
            row: '-',
            field: 'File',
            message: `Error reading file: ${err?.message || 'Invalid Excel format'}`
          });
          return resolve({ isValid: false, errors });
        }
      };

      reader.onerror = () => {
        errors.push({ row: '-', field: 'File', message: 'Unable to read the uploaded file.' });
        resolve({ isValid: false, errors });
      };

      reader.readAsArrayBuffer(file);
    });
  }

  validateUnitsExcel(file: File): Promise<{ isValid: boolean; errors: Array<{ row: number | string; field: string; message: string }> }> {
    return new Promise((resolve) => {
      const errors: Array<{ row: number | string; field: string; message: string }> = [];
      const reader = new FileReader();

      reader.onload = (e: any) => {
        try {
          const buffer = e.target.result;
          const workbook = XLSX.read(buffer, { type: 'array', cellDates: true });

          if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
            errors.push({ row: '-', field: 'File', message: 'No sheets found in the uploaded workbook.' });
            return resolve({ isValid: false, errors });
          }

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          if (!worksheet) {
            errors.push({ row: '-', field: 'Sheet', message: 'The workbook contains an invalid or empty sheet.' });
            return resolve({ isValid: false, errors });
          }

          const rawData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

          if (!rawData || rawData.length === 0) {
            errors.push({ row: '-', field: 'Content', message: 'The uploaded Excel file contains no data.' });
            return resolve({ isValid: false, errors });
          }

          let headerRowIndex = -1;
          for (let i = 0; i < rawData.length; i++) {
            if (rawData[i] && rawData[i].some((cell: any) => cell !== null && cell !== undefined && String(cell).trim() !== '')) {
              headerRowIndex = i;
              break;
            }
          }

          if (headerRowIndex === -1) {
            errors.push({ row: '-', field: 'Content', message: 'The uploaded file is empty.' });
            return resolve({ isValid: false, errors });
          }

          const rawHeaders: any[] = rawData[headerRowIndex];
          const headerMap: { [key: string]: number } = {};

          rawHeaders.forEach((h: any, colIdx: number) => {
            if (h !== null && h !== undefined) {
              const clean = String(h).toLowerCase().replace(/[^a-z0-9]/g, '');
              if (clean) {
                headerMap[clean] = colIdx;
              }
            }
          });

          const findCol = (aliases: string[]): number => {
            for (const alias of aliases) {
              const cleanAlias = alias.toLowerCase().replace(/[^a-z0-9]/g, '');
              if (headerMap[cleanAlias] !== undefined) {
                return headerMap[cleanAlias];
              }
            }
            for (const alias of aliases) {
              const cleanAlias = alias.toLowerCase().replace(/[^a-z0-9]/g, '');
              for (const k of Object.keys(headerMap)) {
                if (k.includes(cleanAlias) || cleanAlias.includes(k)) {
                  return headerMap[k];
                }
              }
            }
            return -1;
          };

          const colCode = findCol(['unitcode', 'code', 'unit_code', 'unitid', 'sku']);
          const colName = findCol(['unitname', 'name', 'unit_name', 'title']);

          if (colCode === -1 && colName === -1) {
            errors.push({
              row: 'Header',
              field: 'Columns',
              message: "Invalid template. Required header 'Unit Code' was not found in the uploaded file."
            });
            return resolve({ isValid: false, errors });
          }

          if (colCode === -1) {
            errors.push({
              row: 'Header',
              field: 'Unit Code',
              message: "Missing mandatory column 'Unit Code' in the uploaded Excel template."
            });
            return resolve({ isValid: false, errors });
          }

          const seenCodes = new Set<string>();
          let dataRowCount = 0;

          for (let r = headerRowIndex + 1; r < rawData.length; r++) {
            const row = rawData[r];
            if (!row || !row.some((c: any) => c !== null && c !== undefined && String(c).trim() !== '')) {
              continue;
            }

            dataRowCount++;
            const displayRowNum = r + 1;

            const getCell = (colIdx: number): any => {
              if (colIdx === -1 || !row || row[colIdx] === undefined || row[colIdx] === null) return '';
              return row[colIdx];
            };

            const isEmpty = (val: any): boolean => {
              if (val === null || val === undefined) return true;
              return String(val).trim() === '';
            };

            const codeRaw = getCell(colCode);
            if (isEmpty(codeRaw)) {
              errors.push({
                row: displayRowNum,
                field: 'Unit Code',
                message: 'Unit Code is mandatory and cannot be empty.'
              });
            } else {
              const codeStr = String(codeRaw).trim().toLowerCase();
              if (seenCodes.has(codeStr)) {
                errors.push({
                  row: displayRowNum,
                  field: 'Unit Code',
                  message: `Duplicate Unit Code '${String(codeRaw).trim()}'. Unit Code must be unique.`
                });
              } else {
                seenCodes.add(codeStr);
              }
            }

            if (colName !== -1) {
              const nameRaw = getCell(colName);
              if (isEmpty(nameRaw)) {
                errors.push({
                  row: displayRowNum,
                  field: 'Unit Name',
                  message: 'Unit Name is mandatory and cannot be empty.'
                });
              }
            }
          }

          if (dataRowCount === 0) {
            errors.push({
              row: '-',
              field: 'Content',
              message: 'The uploaded file does not contain any data rows.'
            });
          }

          return resolve({ isValid: errors.length === 0, errors });
        } catch (err) {
          errors.push({
            row: '-',
            field: 'File',
            message: `Error reading file: ${err?.message || 'Invalid Excel format'}`
          });
          return resolve({ isValid: false, errors });
        }
      };

      reader.onerror = () => {
        errors.push({ row: '-', field: 'File', message: 'Unable to read the uploaded file.' });
        resolve({ isValid: false, errors });
      };

      reader.readAsArrayBuffer(file);
    });
  }

  async upload() {
    if (!this.data || !this.data.url || typeof this.excelImportService[this.data.url] !== 'function') {
      this.snackBar.open(`Import method ${this.data?.url || ''} is not available`, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      this.text = 'Upload';
      return;
    }

    let files = this.getFiles();
    if (!files || files.length === 0) {
      this.snackBar.open("Please select an Excel file to upload", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      this.text = 'Upload';
      return;
    }

    // Pre-import validation for quotations
    if (this.data.url === 'excelImportQuotations' || this.data.module === 'quotations') {
      this.text = "Validating...";
      const firstFile: any = files[0];
      const rawFile: File = firstFile.rawFile || firstFile._file || firstFile;

      const validation = await this.validateQuotationExcel(rawFile);
      if (!validation.isValid) {
        this.text = "Upload";
        this.validationErrors = validation.errors;
        const firstErr = validation.errors[0];
        const displayMsg = firstErr.row && firstErr.row !== '-'
          ? `Row ${firstErr.row} [${firstErr.field}]: ${firstErr.message}`
          : `${firstErr.field}: ${firstErr.message}`;
        this.snackBar.open(displayMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
        return;
      }
    }

    // Pre-import validation for products (validates that Price is not lower than Cost)
    if (this.data.url === 'excelImportProducts' || this.data.url === 'excelImportProductQtyAndPrice' || this.data.module === 'posproduct' || this.data.module === 'product') {
      this.text = "Validating...";
      const firstFile: any = files[0];
      const rawFile: File = firstFile.rawFile || firstFile._file || firstFile;

      const validation = await this.validateProductExcel(rawFile);
      if (!validation.isValid) {
        this.text = "Upload";
        this.validationErrors = validation.errors;
        const firstErr = validation.errors[0];
        const displayMsg = firstErr.row && firstErr.row !== '-'
          ? `Row ${firstErr.row} [${firstErr.field}]: ${firstErr.message}`
          : `${firstErr.field}: ${firstErr.message}`;
        this.snackBar.open(displayMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
        return;
      }
    }

    // Pre-import validation for units (validates that Unit Code is present and non-empty)
    if (this.data.url === 'excelImportUnits' || this.data.url === 'excelImportPosUnits' || this.data.module === 'units') {
      this.text = "Validating...";
      const firstFile: any = files[0];
      const rawFile: File = firstFile.rawFile || firstFile._file || firstFile;

      const validation = await this.validateUnitsExcel(rawFile);
      if (!validation.isValid) {
        this.text = "Upload";
        this.validationErrors = validation.errors;
        const firstErr = validation.errors[0];
        const displayMsg = firstErr.row && firstErr.row !== '-'
          ? `Row ${firstErr.row} [${firstErr.field}]: ${firstErr.message}`
          : `${firstErr.field}: ${firstErr.message}`;
        this.snackBar.open(displayMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
        return;
      }
    }

    this.text = "Processing";
    this.validationErrors = [];
    let dataExport = new FormData();
    files.forEach((file: any) => {
      dataExport.append('file', file.rawFile, file.name);
    });

    this.excelImportService[this.data.url](dataExport).subscribe(
      res => {
        const isSuccess = res && (
          res['status_code'] == Constant.RESPONSE_SUCCESS ||
          res['status'] == 200 ||
          res['status'] == 'OK' ||
          res['status_code'] == 200
        );
        if (isSuccess) {
          if (this.data.url == 'excelImportQuotations' || this.data.module == 'quotations') {
            this.faliedList = res['data'] ? (res['data']['Failed'] || res['data']['failedList'] || []) : [];
            if (!this.faliedList || this.faliedList.length == 0) {
              this.snackBar.open(res['status_message'] || res['message'] || 'Uploaded successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 2000 });
              this.dialogRef.close({ event: 'success', data: 'sd' });
            } else {
              this.uploadedFile = true;
              let errorMsg = this.faliedList.map(item => item.importError || item.message || `${item.field || 'Field'}: invalid`).filter((v, i, a) => a.indexOf(v) === i && v).join(' | ');
              if (!errorMsg) errorMsg = "Some quotation records failed to import.";
              this.snackBar.open(errorMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
            }
          } else if (this.data.url == 'excelImportProducts' || this.data.url == 'excelImportProductQtyAndPrice') {
            this.faliedList = res['data'] ? (res['data']['Failed'] || res['data']['failedList'] || []) : [];
            if (!this.faliedList || this.faliedList.length == 0) {
              this.snackBar.open(res['status_message'] || res['message'] || 'Uploaded successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 2000 });
              this.dialogRef.close({ event: 'success', data: 'sd' });
            } else {
              this.uploadedFile = true;
              let errorMsg = this.faliedList.map(item => item.importError || item.message || item.error || `${item.field || 'Field'}: invalid`).filter((v, i, a) => a.indexOf(v) === i && v).join(' | ');
              if (!errorMsg) errorMsg = "Some product records failed to import.";
              this.snackBar.open(errorMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
            }
          } else if (this.data.url == 'excelImportUnits' || this.data.url == 'excelImportPosUnits' || this.data.module == 'units') {
            this.faliedList = res['data'] ? (res['data']['Failed'] || res['data']['failedList'] || []) : [];
            if (!this.faliedList || this.faliedList.length == 0) {
              this.snackBar.open(res['status_message'] || res['message'] || 'Uploaded successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 2000 });
              this.dialogRef.close({ event: 'success', data: 'sd' });
            } else {
              this.uploadedFile = true;
              let errorMsg = this.faliedList.map(item => item.importError || item.message || item.error || `${item.field || 'Field'}: invalid`).filter((v, i, a) => a.indexOf(v) === i && v).join(' | ');
              if (!errorMsg) errorMsg = "Some unit records failed to import.";
              this.snackBar.open(errorMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
            }
          } else if (this.data.url == 'excelImportSupplier') {
            this.faliedList = res['data'] ? res['data']['Failed'] : [];
            if (!this.faliedList || this.faliedList.length == 0) {
              this.snackBar.open(res['status_message'] || res['message'] || 'Uploaded successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 2000 });
              this.dialogRef.close({ event: 'success', data: 'sd' });
            } else {
              let errorMsg = this.faliedList.map(item => item.importError).filter((v, i, a) => a.indexOf(v) === i && v).join(' | ');
              if (!errorMsg) errorMsg = "Name and Phone Number are required";
              this.snackBar.open(errorMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 4000 });
              this.dialogRef.close({ event: 'success', data: 'sd' });
            }
          } else {
            this.snackBar.open(res['status_message'] || res['message'] || 'Uploaded successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 2000 });
            this.dialogRef.close({ event: 'success', data: 'sd' });
          }
        } else {
          this.snackBar.open(res['status_message'] || res['message'] || 'Failed to upload', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
        this.text = 'Upload';
      },
      error => {
        this.text = "Upload";
        const errMsg = error?.error?.status_message || error?.error?.message || error?.message || 'Error occurred while uploading';
        this.snackBar.open(errMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }

  close() {
    this.dialogRef.close({ event: 'close', data: 'sd' });
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
